import { useEffect } from "react";
import debounce from "lodash.debounce";

// https://reacttraining.com/react-router/web/guides/scroll-restoration
export default function useScrollRestoration() {
  // pathname from window.location, not react-router.  we only want it to restore
  // the scroll position on server page changes
  const pathname = window.location.pathname;

  // save the scroll position for this pathname as the user scrolls
  useEffect(() => {
    const handleScroll = debounce(e => {
      saveScrollPosition(pathname, window.scrollY);
    }, 200);

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [pathname]);

  // restore the scroll position
  useEffect(() => {
    const scrollY = lookupScrollPosition(pathname);
    window.scrollTo(0, scrollY);
  }, [pathname]);
}

/* sessionStorage helper functions */
const sessionKey = pathname => `scrollPosition:${pathname}`;

const lookupScrollPosition = pathname => {
  return sessionStorage.getItem(sessionKey(pathname)) || 0;
};

const saveScrollPosition = (pathname, scrollPosition) => {
  sessionStorage.setItem(sessionKey(pathname), scrollPosition);
};
